import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Payee.List.IRequest;
type Response = Api.Core.Payee.List.IResponse;
type Headers = Api.Core.Payee.List.IHeaders;
const url = '/api/Claims/Payee';
export default async function payeeListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
